import { Scale } from 'lucide-react';
import { Link } from 'react-router-dom';

import { LegalDocumentPage } from './legal-document';
import { PRIVACY_POLICY_OWNER_EMAIL } from './privacy-policy-content';
import {
  TERMS_EFFECTIVE_DATE_LABEL,
  TERMS_VERSION,
  termsSections,
} from './terms-content';

export function TermsPage() {
  return (
    <LegalDocumentPage
      title="Termos e Condições"
      icon={Scale}
      asideSummary="Regem a utilização da BelaHora por profissionais e empresas, incluindo conta, subscrição, responsabilidade e proteção de dados."
      meta={[
        { label: 'Versão', value: TERMS_VERSION },
        { label: 'Entrada em vigor', value: TERMS_EFFECTIVE_DATE_LABEL },
        { label: 'Contacto', value: PRIVACY_POLICY_OWNER_EMAIL },
      ]}
      intro={
        <>
          Esta Aplicação destina-se exclusivamente a Utilizadores Comerciais. Em
          matéria de dados pessoais, estes Termos são complementados pela{' '}
          <Link
            to="/privacidade"
            className="font-semibold text-white underline underline-offset-4"
          >
            Política de Privacidade
          </Link>{' '}
          e pelo{' '}
          <Link
            to="/dpa"
            className="font-semibold text-white underline underline-offset-4"
          >
            Acordo de Tratamento de Dados
          </Link>
          .
        </>
      }
      sections={termsSections}
    />
  );
}
